import {Component, OnInit, OnDestroy} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {CookieService} from "./services/CookieService";
import {AuthInfoDTO} from "../core/dto/AuthInfoDTO";
import {environment} from "../environments/environment";
import {AuthorizationService} from "../core/authorization/AuthorizationService";
import {Router} from '@angular/router';
import {LocalizationService} from "./services/localizationService";
import {Subscription} from 'rxjs';
import {ConfigurationService} from "./services/configuration.service";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Modernize Angular Admin Tempplate';

    loginSuccess = false;
    loggedUser: AuthInfoDTO;
    public activeUser: AuthInfoDTO;

    // Abonelikleri takip etmek için
    private userSubscription: Subscription;

    constructor(
        private cookieService: CookieService,
        private authorizationService: AuthorizationService,
        private router: Router,
        private localizationService: LocalizationService,
        private configurationService: ConfigurationService
    ) {
        this.initLocalization();
        this.initUserAuth();
    }

    ngOnInit() {
        // AuthorizationService'ten gelen kullanıcı bilgilerine abone ol
        this.userSubscription = this.authorizationService.activeUser.subscribe(
            user => {
                if (user) {
                    this.activeUser = user;
                }
            }
        );
    }

    ngOnDestroy() {
        // Component yok edildiğinde abonelikleri temizle
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    /**
     * Kullanıcı yetkilendirme sürecini başlatır
     */
    private initUserAuth(): void {
        const cookie = this.cookieService.getCookie(this.cookieService.cookieName);

        if (cookie && cookie !== "") {
            // Cookie varsa, kullanıcı bilgilerini al
            const authInfo: AuthInfoDTO = this.cookieService.getUserInfo(this.cookieService.cookieName);

            if (authInfo) {
                this.loginSuccess = true;
                this.loggedUser = authInfo;
                this.cookieService.headerToken = cookie;

                // Temel kullanıcı bilgilerini ayarla
                // AuthorizationService içinde getAccountInfo çağrısı yapılacak ve kullanıcı bilgileri güncellenecek
                this.authorizationService.setActiveUser(this.loggedUser);
            }
        } else {
            if(this.configurationService.isRequestOfPublicScreen()==false){
                // Cookie yoksa ve public bir sayfa değilse, çıkış yap ve giriş sayfasına yönlendir
                this.authorizationService.resetActiveUser();
                let _param=environment.apiUrl.endsWith("/")?"":"/"
                window.location.href = environment.apiUrl+_param + "login?redirectUrl=" + window.location.href;
            }
        }
    }

    private initLocalization(): void {
        // Tarayıcı dilini veya kullanıcı tercihini kontrol et
        const savedLang = localStorage.getItem('preferredLanguage') || sessionStorage.getItem('activeLanguage');

        if (savedLang && ['tr', 'en', 'de'].includes(savedLang)) {
            this.localizationService.setCurrentLang(savedLang);
        } else {
            // Varsayılan Türkçe veya tarayıcı dili
            const browserLang = navigator.language.split('-')[0];
            const lang = ['tr', 'en', 'de'].includes(browserLang) ? browserLang : 'tr';
            this.localizationService.setCurrentLang(lang);
        }
    }

    public changeLanguage(lang: string): void {
        if (['tr', 'en', 'de'].includes(lang)) {
            this.localizationService.setCurrentLang(lang);
            localStorage.setItem('preferredLanguage', lang);
        }
    }
}
